import React, { useEffect, useState } from 'react';
import {Platform, Text, View, StyleSheet,Button, Alert,FlatList, Image,TouchableOpacity, SafeAreaView, ScrollView  } from 'react-native'
import { useNavigation } from '@react-navigation/native';
import { useTailwind } from 'tailwind-rn';
import * as FileSystem from 'expo-file-system';
import Modal from "react-native-modal";



//My components 
import GeneratedElelemnt from '../../GeneratedElements/GeneratedElement1';

const CuandroPestana = ({ nombre, contenido }) => {

    const tailwind = useTailwind();

    const [shouldShow, setShouldShow] = useState(false);

    console.log("Contenido")
    console.log(contenido)

    return (
        <View style ={ tailwind("my-1") }>
            <TouchableOpacity  onPress={ () => setShouldShow(!shouldShow) } style={ tailwind("text-xs bg-matconblue text-gray-800 p-4 m-2 px-14 rounded-md justify-center") } >
                <Text style={ tailwind("font-bold uppercase text-white text-center") }> { nombre["esp"] } </Text>
            </TouchableOpacity>
            <View style={ tailwind("text-xs bg-white  p-2 m-2 px-14 rounded-md justify-center") } >
                {shouldShow ? (
                    <View>
                        {
                            contenido.map((subcontent, index) => {
                                return (
                                    <GeneratedElelemnt
                                        tipo = { subcontent["tipo"] }
                                        align = { subcontent["align"] }
                                        firsttext = { subcontent["firsttext"] }
                                        text = { subcontent["text"] }
                                        listelements = { subcontent["listelements"] }
                                    />
                                )
                            })
                        }
                    </View>
                ) : null}
            </View>

        </View>
    )

}

export default CuandroPestana